// generateArticlesZoneFightGym.ts
import dayjs from "dayjs";
export function generateArticlesZoneFightGym({
  member_info,
  ListFrais,
  memberSubscription,
  PrixAassurance,
  ListTransactions,
  TotalsByPaymentMethod,
  active_subscription,
  memberServicesCredits,
}: {
  member_info: any;
  ListFrais: any[];
  memberSubscription: any[];
  PrixAassurance: string;
  ListTransactions: any[];
  TotalsByPaymentMethod: Record<string, number | string>;
  active_subscription: any;
  memberServicesCredits: any[];
}) {
  console.log("member_info lslsl");
  console.log(member_info);
  return {
    firstArticles: [
      {
        type: "article",
        title: "",
        description: `Après la visite des installations et du matériel du club, l’adhérent a pris connaissance du règlement intérieur et des offres et avant la signature du présent contrat d’abonnement  il a été convenu ce qui suit.`,
      },
      {
        type: "article",
        title: "1 - OBJET DU CONTRAT",
        description: `Le présent contrat d’abonnement pour objet la souscription d’un abonnement donnant droit à l’adhérent d’utiliser les installations en libre-service avec accès illimité aux jours et heures d’ouverture du club dans le cadre du forfait de base comprenant : cardio-training et musculation, selon un prix et des facilités financières indiqués dans le présent contrat.`,
      },
      {
        type: "article",
        title: "2 - DROITS D’INSCRIPTION",
        description: `A la signature du présent contrat, l’adhérent s’acquitte par toutes modalités de règlement définies ci-après.`,
        spaceY: `0.6`,
        table: {
          headers: ["Les frais", "Montant TTC"],
          data: ListFrais,
        },
      },
      {
        type: "article",
        description: `Le présent contrat d’abonnement est accepté selon les conditions particulières ci-dessous définies et les conditions générales figurant au verso.`,
      },
      {
        type: "article",
        title: "3 - CHOIX DE L’ABONNEMENT",
        subtitle:
          "(avec engagement pour une durée minimale incompressible de 12 mois ou de 24 mois)",
        description: `Le présent contrat d’abonnement est accepté selon les conditions particulières ci-dessous définies et les conditions générales figurant au verso.`,
        spaceY: `0.6`,
        table: {
          headers: [
            "Durée",
            "Pack",
            "Date de début",
            "Date de fin",
            "Prix du pack",
            "Remise et promo",
            "Total Services",
            "Montant TTC",
          ],
          data: memberSubscription,
        },
      },
      // {
      //   type: "article",
      //   description: `Activités inclus`,
      //   descriptioBold: "bold",
      //   spaceY: `0.4`,
      //   table: {
      //     headers: [
      //       "Activité",
      //       "Prix",
      //       "Total des séances",
      //       "Séances restantes",
      //     ],
      //     data: memberServicesCredits,
      //   },
      // },

      {
        type: "article",
        description: `Le présent contrat d’abonnement est conclu pour une durée minimale incompressible de 12 mois ou de 24 mois`,
        spaceY: `0.6`,
      },
      {
        type: "article",
        description: `Observation :`,
        descriptioBold: "bold",
        spaceY: `0.6`,
      },
      {
        type: "article",
        description: `${member_info?.comment?.toString() ?? ""}`,
        spaceY: `0.6`,
      },

      {
        type: "article",
        title: "4 - ASSURANCE INCLUS",
        description: `Souscrire à une assurance n’est pas seulement une formalité, mais une garantie de protection contre les imprévus. Elle assure votre sécurité, tout en vous permettant de respecter la réglementation en vigueur.`,
      },

      {
        type: "article",
        title: "5 - OPTIONS",
        description: `Souscription au coaching personnel :`,
        spaceY: `0.8`,
      },

      {
        type: "article",
        description: `[   ] 10 SEANCES :  2000 DHS                                                                                                        [   ] 25 SEANCES :  4000 DHS`,

        descriptioBold: "bold",
        spaceY: `0.8`,
      },
      {
        type: "article",
        description: `[   ] TRANSFERT D'ABONNEMENT : 1000 DHS                                                                           [   ] BILAN SPORTIF / PERSONNALISÉ : 900 DHS`,

        descriptioBold: "bold",
        spaceY: `0.8`,
      },
      {
        type: "article",
        description: `[   ] REPORT D'ABONNEMENT : 1000 DHS`,

        descriptioBold: "bold",
        spaceY: `2`,
      },

      {
        type: "article",
        title: "6 - MODALITÉS DE RÈGLEMENT",
        description: `SOIT UN MONTANT TOTAL A REGLER DE :`,
        priceDesc: active_subscription?.total_amount?.toFixed(2) + " DH",
        spaceY: `0.8`,
        table: {
          headers: ["Libellé", "Date de paiement", "Montant payé (DH)"],
          data: ListTransactions,
        },
      },
      {
        type: "article",
        description: `L’abonnement est payable selon le mode suivant :`,
        spaceY: `0.8`,
      },
      {
        type: "article",
        description: `Espèces :`,
        priceDesc: `${TotalsByPaymentMethod["Espèce"] ?? "0.00"} DH`,
        descriptioBold: "bold",
        spaceY: `0.8`,
      },
      {
        type: "article",
        description: `Virement/TPE :`,
        priceDesc: `${TotalsByPaymentMethod["Virement/TPE"] ?? "0.00"} DH`,
        descriptioBold: "bold",
        spaceY: `0.8`,
      },
      {
        type: "article",
        description: `Chèque bancaire :`,
        priceDesc: `${TotalsByPaymentMethod["Chèque bancaire"] ?? "0.00"} DH`,
        descriptioBold: "bold",
        spaceY: `0.8`,
      },

      {
        type: "article",
        description: `Pour tout règlement en espèce, prière d’exiger un reçu. Ce dernier peut être demandé par la direction à tout moment en cas de vérification de l’adhésion ou de réclamation.`,
        descriptionColor: "red",
      },
      {
        type: "article",
        description: `La direction se réserve le droit d’annuler une inscription`,
      },
      {
        type: "article",
        description: `En justifiant les motifs dans un délai de 8 jours`,
      },
      {
        type: "article",
        description: `Fait à`,
        priceDesc: `ZONE FIGHT GYM, le ${dayjs().format("DD/MM/YYYY")}`,
        descriptioBold: "bold",
      },
      {
        type: "article",
        description: `L’adhérent reconnait en signant ci-dessous, avoir pris connaissance des conditions Générales au verso et les accepter sans réserve. `,
        descriptioBold: "bold",
      },
    ],

    generalArticles: [
      {
        type: "article",
        description: `Les conditions générales au-dessous régissent les relations contractuelles entre le club de remise en forme objet de contrat et l'adhérent Contractant. Aucune condition particulière ne peut, sauf acceptation formelle et écrite du club ou de son mandataire commercialisant, prévaloir contre les conditions générales.
Toute condition contraire posée par l'adhérent sera donc caduque, quel que soit le moment où elle aura pu être portée à sa connaissance.`,
      },
      {
        type: "article",
        title: "Objet du contrat",
        description: `Après avoir visité les installations du club et/ou avoir pris connaissance des prestations proposées, l'adhérent déclare souscrire un contrat d'abonnement nominatif incessible lui autorisant l'accès au club dans le cadre du forfais choisi selon un prix et des modalités financières indiqués dans le présent contrat.`,
      },
      {
        type: "article",
        title: "Définition",
        description: `La carte de membre est à durée déterminée suivant la durée souscrite au départ du contrat. En cas de perte ou le vol, le remplacement de sa carte sera facturé à 200 Dhs TTC à l'abonné.
Le renouvellement fait l'objet d'un nouveau contrat.`,
      },
      {
        type: "article",
        title: "Tarification",
        description: `Le prix fixé sur le contrat est indiqué en dirhams constants
Le club se réserve la possibilité d'actualiser le prix de l'abonnement lors de la réactivation d'un nouveau contrat.
Toutes prestations complémentaires non prévues au contrat pourront être facturées en supplément.`,
      },
      {
        type: "article",
        title: "Conditions d'accès",
        description: `Le membre muni de sa carte en cours de validité est autorisé à accéder au club et à assister au cours dans la cadre des horaires affichés_ Les éventuelles modifications sont portées à la connaissance des membres (horaires d'été,
Horaires du Ramadan, fermeture pendant les travaux, cas de force majeure).
Le membre reconnait à la direction du club le droit d'exclure de l'établissement, sans préavis ni indemnité, toute personne dont l'attitude, le comportement ou la tenue serait contraire aux bonnes mœurs, ou notoirement gênant pour les autres membres, ou non conforme au présent contrat ou règlement intérieur du club.`,
      },
      {
        type: "article",
        title: "Modalités de transfert / résiliation",
        description: `Le contrat ne peut être ni transféré. Cependant il est possible de souscrire à l'option "transfert" qui donne le droit à chaque adhérent souscripteur a un transfert ainsi qu'à un mois de report durant l'abonnement en cours. Si l'option n'a pas été souscrite le jour de l'adhésion, il ne pourra être prétendu à aucun transfert ni aucun report.
Le contrat d'abonne ment local n'est valable que dans le club mentionné dans l'article III - "Choix 
de l'abonnement".
Si aucun choix n'est précisé, le club attribué par défaut sera le club du lieu d'inscription. Le choix du club doit être précisé le jour de l'inscription et ne peut en aucun cas être modifié.`,
      },
      {
        type: "article",
        title: "Vestiaires / Dépôt",
        description: `L'adhérent a la faculté d'utiliser des casiers individuels à fermeture traditionnelle dont l'utilisation est limitée à la durée de la séance. L'adhérent a l'obligation de se pourvoir d'un cadenas afin de pouvoir le fermer Le cadenas est reste la propriété de ce dernier.
Il est strictement interdit de laisser ses affaires personnelles à l'intérieur des casiers après avoir quitté le Club car les cadenas seront automatiquement coupés sans aucune  indemnisation pour l'adhérent. Il est rappelé expressément à l'adhérent que les vestiaires ne font l'objet d'aucune surveillance spécifique, il est donc recommandé de ne pas y entreposer des objets de valeur.`,
      },
      {
        type: "article",
        title: "Règlement intérieur / Règles de Sécurité et Hygiène",
        description: `L'adhérent déclare se conformer aux conditions générales et au règlement intérieur, y adhérer sans restriction ni réserve et de respecter les consignes suivantes :
        • Présence des enfants non-inscrits exclue dans l'enceinte du club pour des raisons de sécurité.
        • Interdiction de fumer à l'intérieur de l'établissement.
        • Le port de vêtement et de chaussures de sport spécifiques et exclusifs de toutes autres utilisations est obligatoire.
        • Disposition de serviette et de matériel d'hygiène propre à chaque adhérent.
        • Respect des horaires des cours

Toute autre personne extérieure, bénéficiant d'une invitation du club ou d'une séance découverte est soumise au même règlement
Que les adhérents inscrits, et doit déposer obligatoirement une pièce d'identité pendant sa séance et uniquement sur RDV.`,
      },
      {
        type: "article",
        title: "Attestation / Certificat médical / Décharge médical :",
        description: `L'adhérent garantit au club du réseau où il est inscrit, d'avoir été examiné par un médecin et étant capable de pratiquer une activité sportive, qu'il ne souffre d'aucune blessure, maladie ou handicap, qu'il n'a jamais eu de problèmes cardiaques ou respiratoires décelés à ce jour et d'avoir pris régulièrement toute précaution nécessaire pour sa santé. Il doit remettre au club dans les 2 jours qui suivent l'adhésion, un certificat médical attestant son aptitude à la pratique sportive au sein du club.
A défaut du certificat médical, l'adhérent décharge le club de toutes réclamations, actions juridiques, frais, dépenses et requêtes respectivement à des blessures ou dommages occasionnés et causés de quelque manière que ce soit, découlant ou en Raison du fait qu'il pratique cette activité sportive, et ce nonobstant le fait que cela ait pu être causé ou occasionné par négligence ou être lié à un manquement à ses responsabilités à titre d'occupant des lieux. L'adhérent consent à assumer tous les risques connus et inconnus, et toutes les conséquences afférentes ou liées au fait qu'il participe aux activités sportives du club. C'est en toute connaissance de cause que ce dernier accepte le présente décharge médicale.`,
      },
      {
        type: "article",
        title: "Données personnelles",
        description: `En souscrivant au présent contrat vous reconnaissez le droit à l'utilisation de vos données personnelles à des fins de prospection, information ou tout autre communication par nos soins ou par toutes entreprises partenaires, sauf demande contraire manuscrite envoyée, par le titulaire ou ayant droit, par courrier recommandé avec accusé de réception au siège de l'entreprise`,
      },
      {
        type: "article",
        title: "Assurance",
        description: `Le club est assuré pour les dommages engageant sa responsabilité civile et celle de son personnel Conformément aux dispositions légales. Cette assurance a pour objet de garantir le club contre les conséquences pécuniaires relevant de la force majeure, des frais administratifs d'un montant forfaitaire de 2000,00 Dhs seront retenus en une seule fois pour clôture du dossier. Par motif de cas de force majeure, il est limitativement fait référence aux cas suivants : maladie ou accident grave empêchant définitivement le membre de bénéficier des services du club, décès, mutation professionnelle du fait de l'employeur. Une assurance complémentaire peut être souscrite le jour de l'adhésion, elle ne pourra en aucun cas être contracté postérieurement.`,
      },

      {
        type: "article",
        title: "Résiliation à l'initiative du Club",
        description: `L'abonnement est résilié de plein droit par le club aux motifs suivants :
En cas de fraude dans la constitution du dossier d'abonnement, fausse déclaration, falsification.
En cas de fraude dans l'utilisation de la carte d’accès du club. En cas de défaut de paiement, Étant précisé qu'un incident de paiement donne lieu à la suspension de la carte d'abonnement du club en attendant la régularisation sans que les mois durant le blocage ne soient récupérables.
En cas d'autres incidents de paiements, l'adhérent sera redevable et devra s'acquitter de l'intégrité de sa dette auprès de la société.`,
      },
    ],
  };
}
